import { render, staticRenderFns } from "./NuevaObservacion.vue?vue&type=template&id=4c911af6"
import script from "./NuevaObservacion.vue?vue&type=script&lang=js"
export * from "./NuevaObservacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports